import React from 'react';
import './PortfolioList.css';


 
const ProjectList = ({id, title, active, setSelected}) => {
  return ( 
    <li
        key={id}
        className={active ? "button active" : "button"}
        onClick={() => setSelected(id)}>
        {title}
    </li>
  )
}
 
export default ProjectList;